module.exports = {
  title: 'Dev Ramble', // Required
  description: 'Guides, how-to\'s and other nonsensical ramblings from a software engineer',
  primaryColor: '#bc82fa', // Required
  showHeaderImage: false,
  showShareButtons: true,
  postsPerPage: 10, // Required
};
